// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import { Col, Container, Modal, Row } from 'react-bootstrap';
// import { DataGrid } from '@mui/x-data-grid';
// import { Alert, Button, Snackbar, Switch } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { DeleteOne_Rotation_Data, GetAll_Rotation_Data } from '../Redux/Actions/Rotations_Actions';
// import CopyToClipboard from 'react-copy-to-clipboard';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { Link } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import SyncAltIcon from '@mui/icons-material/SyncAlt';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { Notify } from '../Utility/Notify';
// import { useTheme } from '@mui/material/styles';
// export const ManageMoreRotationPage = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   // modal Delete
//   const [showdelete, setShowdelete] = useState(false);
//   const handleClosedelete = () => setShowdelete(false);

//   const dispatch = useDispatch();

//   const getAllRotation = async () => {
//     await dispatch(GetAll_Rotation_Data());
//   };

//   useEffect(() => {
//     getAllRotation();
//   }, []);

//   const resallrotation = useSelector((state) => state.AllRotation.Rotation);
//   let AllrotationArray = Array.isArray(resallrotation?.data) ? resallrotation.data : [];

//   const [rows, setRows] = useState([]);

//   useEffect(() => {
//     if (Array.isArray(resallrotation?.data)) {
//       const transformedRows = resallrotation.data.map((item) => ({
//         id: item._id, // استخدام _id كـ id في الجدول
//         RotationId: item._id,
//         Sales: item.sales.map((sale) => `${sale.salesId.name} (${sale.maxLeads})`).join(', '),
//         Projects: item.projects.map((project) => project.name).join(', '), // دمج أسماء المشاريع
//         Channel: item.channels.map((channel) => channel.name).join(', '), // دمج أسماء القنوات
//         CreatedAt: new Date(item.createdAt).toLocaleDateString(), // تنسيق تاريخ الإنشاء
//         Active: item.active, // حالة التبديل
//       }));
//       setRows(transformedRows);
//     }
//   }, [resallrotation]);

//   const handleChangeSwitch = (id) => (event) => {
//     setRows((prevRows) =>
//       prevRows.map((row) => (row.id === id ? { ...row, Active: event.target.checked } : row)),
//     );
//   };

//   const handleButtonClickupdate = async (id, buttonType) => {
//     // console.log(`Button clicked for Rotation ID: ${id}, Type: ${buttonType}`);
//   };

//   const [decomentid, setdecumentid] = useState();
//   const handleButtonClickdelete = (id, buttonType) => {
//     // console.log(`Button clicked for Rotation ID: ${id}, Type: ${buttonType}`);
//     setdecumentid(id);
//     setShowdelete(true);
//   };

//   //clipboard copy channal id
//   const [open, setOpen] = useState(false);
//   const handleCopy = () => {
//     setOpen(true); // عرض رسالة تأكيد عند النسخ
//     setTimeout(() => setOpen(false), 2000); // إخفاء الرسالة بعد 2 ثانية
//   };

//   const columns = [
//     {
//       field: 'RotationId',
//       headerName: 'RotationId',
//       width: 150,
//       renderCell: (params) => (
//         <div style={{ cursor: 'pointer', textAlign: 'center' }}>
//           {' '}
//           <CopyToClipboard onCopy={handleCopy}>
//             <div onClick={() => navigator.clipboard.writeText(params.row.id)}>
//               <ContentCopyIcon />
//             </div>
//           </CopyToClipboard>
//           <Snackbar open={open} autoHideDuration={2000}>
//             <Alert severity="success">Copy Done</Alert>
//           </Snackbar>
//         </div>
//       ),
//     },
//     { field: 'Sales', headerName: 'Sales', width: 200 },
//     { field: 'Projects', headerName: 'Projects', width: 200 },
//     { field: 'Channel', headerName: 'Channel', width: 200 },
//     { field: 'CreatedAt', headerName: 'Created At', width: 150 },
//     {
//       field: 'Active',
//       headerName: 'Active',
//       width: 150,
//       renderCell: (params) => (
//         <Switch
//           checked={params.row.Active || false}
//           onChange={handleChangeSwitch(params.row.id)}
//           inputProps={{ 'aria-label': 'controlled' }}
//           disabled={true} // هذا سيجعل الـ Switch غير قابل للتفاعل
//         />
//       ),
//     },
//     {
//       field: 'Action',
//       headerName: 'Action',
//       width: 200,
//       renderCell: (params) => (
//         <div>
//           <Button
//             variant="outlined"
//             onClick={() => handleButtonClickdelete(params.row.id, 'delete')}
//           >
//             <DeleteIcon />
//           </Button>

//           <Link to={`/EditMoreRotation/${params.row.id}`} style={{ textDecoration: 'none' }}>
//             <Button
//               variant="outlined"
//               onClick={() => handleButtonClickupdate(params.row.id, 'edit')}
//               style={{ marginRight: 10 }}
//               className="mx-2"
//             >
//               <SyncAltIcon />
//             </Button>
//           </Link>
//         </div>
//       ),
//     },
//   ];

//   // delete rotation
//   const handledeleting = async (e) => {
//     e.preventDefault();
//     await dispatch(DeleteOne_Rotation_Data(decomentid));

//     Notify('success', 'Rotation Deleted Successfully', 'success');

//     setTimeout(() => {
//       window.location.reload();
//     }, 1500);
//   };

//   // تحديد المسار بناءً على دور المستخدم
//   const moreRotationRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeads' // Admin يذهب إلى /MoreRotation
//       : userlogin?.data?.role === 'Marketer'
//         ? '/ALLLeadsForMarketer' // Marketer يذهب إلى /MarketerMoreRotation
//         : '/'; // مسار افتراضي لأي دور آخر

//   return (
//     <Container className="startpage">
//       {/* model deleting rotation */}

//       <Modal style={{ zIndex: '40000' }} show={showdelete} onHide={handleClosedelete}>
//         <Modal.Header
//           closeButton
//           style={{
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           }}
//         >
//           <Modal.Title
//             style={{
//               color: mode === 'dark' ? '#90caf9' : '#666',
//               backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//             }}
//           >
//             {' '}
//             Delete Rotation
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body
//           style={{
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           }}
//         >
//           {' '}
//           Are you sure For deleting this Rotation !
//         </Modal.Body>
//         <Modal.Footer
//           style={{
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           }}
//         >
//           <Button
//             className="mx-2"
//             style={{ border: '1px solid #102dff' }}
//             variant="secondary"
//             onClick={handleClosedelete}
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handledeleting}
//             style={{
//               color: mode === 'dark' ? '#90caf9' : '#fff',
//               backgroundColor: mode === 'dark' ? '#252525' : '#102dff',
//             }}
//           >
//             Confirm Deleting
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <div className="my-3">
//         <Link
//           to={moreRotationRoute}
//           style={{ textDecoration: 'none', color: '#102dff', fontWeight: 'bold' }}
//         >
//           <span style={{ fontWeight: 'bold' }}>Home</span>
//         </Link>
//         <KeyboardDoubleArrowRightIcon />
//         <Link
//           to={`/MoreRotation`}
//           style={{ textDecoration: 'none', color: '#666', fontWeight: 'bold' }}
//         >
//           <span style={{ color: '#666' }}>Rotation</span>
//         </Link>

//         <KeyboardDoubleArrowRightIcon />
//         <span style={{ color: '#666' }}>Manage Rotation</span>
//       </div>

//       <Row>
//         <Col sm={0}></Col>
//         <Col sm={12}>
//           <div style={{ height: 700, width: '100%' }}>
//             <DataGrid rows={rows} columns={columns} pageSize={5} rowsPerPageOptions={[5]} />
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };






















// 20-5-2026
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { DeleteOne_Rotation_Data, GetAll_Rotation_Data } from '../Redux/Actions/Rotations_Actions';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconCopy    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconEdit    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconTrash   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const IconWarning = () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const IconClose   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconRotation = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>;
const IconPlus    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconTrend   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;

/* ─── CSS (portal modal, injected once) ─────────────────────────────────── */
const CSS = `
  .mr-btn { display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;border:1px solid transparent;cursor:pointer;background:transparent;transition:all 0.18s;text-decoration:none;color:#7B829A; }
  .mr-btn:hover { transform:translateY(-1px); }
  .mr-btn.edit { border-color:#E8EAF0;background:#F7F8FC;color:#1A3ECF; }
  .mr-btn.edit:hover { background:#EEF1FF;border-color:#1A3ECF; }
  .mr-btn.del  { border-color:#FFE4E4;background:#FFF5F5;color:#E53935; }
  .mr-btn.del:hover  { background:#FFE4E4;border-color:#E53935; }

  .mr-overlay { position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.75);backdrop-filter:blur(10px);animation:mr-fade 0.22s ease both; }
  @keyframes mr-fade { from{opacity:0} to{opacity:1} }
  .mr-card { width:100%;max-width:480px;margin:0 20px;border-radius:28px;padding:40px 32px 36px;background:#fff;box-shadow:0 40px 100px rgba(0,0,0,0.35);position:relative;animation:mr-slide 0.28s cubic-bezier(0.34,1.2,0.64,1) both; }
  .mr-card.dark-m { background:linear-gradient(135deg,#1a1f2e,#141829);color:#E4E8F5; }
  @keyframes mr-slide { from{opacity:0;transform:translateY(28px) scale(0.95)} to{opacity:1;transform:none} }
  .mr-close { position:absolute;top:18px;right:18px;width:36px;height:36px;border-radius:12px;border:1px solid #E8EAF0;background:#F7F8FC;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#7B829A;transition:all 0.2s; }
  .mr-close:hover { background:#FFE4E4;border-color:#E53935;color:#E53935;transform:scale(1.05); }
  .dark-m .mr-close { background:#252D4A;border-color:#3A4570;color:#9099c0; }
  .mr-icon { width:80px;height:80px;border-radius:50%;background:linear-gradient(135deg,#FFF3F3,#FFE4E4);border:2px solid #FFBDBD;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;color:#E53935;box-shadow:0 8px 24px rgba(229,57,53,0.18); }
  .dark-m .mr-icon { background:linear-gradient(135deg,#2a1a1a,#3a2525);border-color:#5a3535; }
  .mr-title { font-family:'DM Sans',sans-serif;font-size:21px;font-weight:700;color:#1C2340;text-align:center;margin:0 0 9px;letter-spacing:-0.3px; }
  .dark-m .mr-title { color:#E4E8F5; }
  .mr-sub { font-family:'DM Sans',sans-serif;font-size:14px;color:#7B829A;text-align:center;margin:0 0 26px;line-height:1.65; }
  .mr-actions { display:flex;gap:12px; }
  .mr-cancel { flex:1;padding:14px;border-radius:14px;border:1.5px solid #E8EAF0;background:#F7F8FC;font-family:'DM Sans',sans-serif;font-size:15px;font-weight:600;color:#1C2340;cursor:pointer;transition:all 0.2s; }
  .mr-cancel:hover { background:#EBEDF5;transform:translateY(-1px); }
  .dark-m .mr-cancel { background:#252D4A;border-color:#3A4570;color:#E4E8F5; }
  .mr-confirm { flex:1;padding:14px;border-radius:14px;border:none;background:linear-gradient(135deg,#E53935,#C62828);font-family:'DM Sans',sans-serif;font-size:15px;font-weight:700;color:#fff;cursor:pointer;transition:all 0.2s;box-shadow:0 6px 20px rgba(229,57,53,0.3);display:flex;align-items:center;justify-content:center;gap:8px; }
  .mr-confirm:hover { background:linear-gradient(135deg,#EF5350,#D32F2F);transform:translateY(-2px); }
  .mr-confirm:disabled { background:#E8EAF0;color:#B0B5C9;box-shadow:none;transform:none;cursor:not-allowed; }
  .mr-spin { width:16px;height:16px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:mr-spin 0.7s linear infinite; }
  @keyframes mr-spin { to{transform:rotate(360deg)} }
`;

let cssInjected = false;
const injectCSS = () => { if (!cssInjected) { cssInjected=true; const el=document.createElement('style'); el.innerHTML=CSS; document.head.appendChild(el); } };

/* ─── Delete Modal ───────────────────────────────────────────────────────── */
const DeleteModal = ({ isDark, onClose, onConfirm, loading }) =>
  createPortal(
    <div className="mr-overlay" onClick={e => { if (!loading && e.target===e.currentTarget) onClose(); }}>
      <div className={`mr-card ${isDark?'dark-m':''}`}>
        <button className="mr-close" onClick={onClose} disabled={loading}><IconClose /></button>
        <div className="mr-icon"><IconWarning /></div>
        <p className="mr-title">Delete Rotation?</p>
        <p className="mr-sub">This rotation will be permanently deleted<br/>from the system. This action cannot be undone.</p>
        <div className="mr-actions">
          <button className="mr-cancel" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="mr-confirm" onClick={onConfirm} disabled={loading}>
            {loading ? <><div className="mr-spin"/>Deleting…</> : <><IconTrash/>Delete Rotation</>}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );

/* ─── Constants ──────────────────────────────────────────────────────────── */
const EXPANDED_WIDTH = 242;

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const ManageMoreRotationPage = () => {
  injectCSS();

  const dispatch = useDispatch();
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';

  const [userlogin,    setUserlogin]    = useState(null);
  // const [sidebarWidth, setSidebarWidth] = useState(EXPANDED_WIDTH);
    const sidebarWidth = useSidebarWidth();
  
  const [searchTerm,   setSearchTerm]   = useState('');
  const [page,         setPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [copyOpen,     setCopyOpen]     = useState(false);
  const [deleteId,     setDeleteId]     = useState(null);
  const [deleteLoading,setDeleteLoading]= useState(false);
  const [rows,         setRows]         = useState([]);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  // useEffect(() => {
  //   const h = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', h);
  //   const el = document.querySelector('nav,aside,[class*="sidebar"],[class*="Sidebar"]');
  //   let ro;
  //   if (el) {
  //     ro = new ResizeObserver(() => { const w = el.getBoundingClientRect().width; if (w>0) setSidebarWidth(w); });
  //     ro.observe(el);
  //   }
  //   return () => { window.removeEventListener('sidebarResized', h); if (ro) ro.disconnect(); };
  // }, []);

  const getAllRotation = async () => { await dispatch(GetAll_Rotation_Data()); };
  useEffect(() => { getAllRotation(); }, []);

  const resallrotation = useSelector(s => s.AllRotation.Rotation);

  useEffect(() => {
    if (Array.isArray(resallrotation?.data)) {
      setRows(resallrotation.data.map(item => ({
        id:        item._id,
        sales:     item.sales.map(s => `${s.salesId?.name} (${s.maxLeads})`).join(', '),
        projects:  item.projects.map(p => p.name).join(', '),
        channels:  item.channels.map(c => c.name).join(', '),
        createdAt: new Date(item.createdAt).toLocaleDateString(),
        active:    item.active,
      })));
    }
  }, [resallrotation]);

  /* filter */
  const filtered = rows.filter(r => {
    if (!searchTerm) return true;
    const q = searchTerm.toLowerCase();
    return r.sales?.toLowerCase().includes(q) || r.projects?.toLowerCase().includes(q) || r.channels?.toLowerCase().includes(q);
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page-1)*itemsPerPage, page*itemsPerPage);

  /* stats */
  const activeCount = rows.filter(r => r.active).length;

  /* delete */
  const handleDelete = async () => {
    setDeleteLoading(true);
    await dispatch(DeleteOne_Rotation_Data(deleteId));
    setDeleteLoading(false);
    setDeleteId(null);
    Notify('success', 'Rotation deleted successfully', 'success');
    getAllRotation();
  };

  /* page numbers */
  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({length:totalPages},(_,i)=>i+1);
    const pages=[];
    if (page<=4) pages.push(1,2,3,4,5,'...',totalPages);
    else if (page>=totalPages-3) pages.push(1,'...',totalPages-4,totalPages-3,totalPages-2,totalPages-1,totalPages);
    else pages.push(1,'...',page-1,page,page+1,'...',totalPages);
    return pages;
  };

  const homeLink = userlogin?.data?.role==='Admin' ? '/AllLeadsForAdmin'
    : userlogin?.data?.role==='Marketer' ? '/ALLLeadsForMarketer' : '/';

  /* ── render ── */
  return (
    <>
      <div
        className={`ap-shell ${isDark?'dark':''}`}
        style={{ position:'fixed', top:'50px', left:sidebarWidth, right:0, bottom:0, transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)', overflowY:'auto', overflowX:'hidden', display:'flex', flexDirection:'column' }}
      >

        {/* Breadcrumb */}
        <section style={{ padding:'16px 20px 0', flexShrink:0 }}>
          <div style={{ display:'flex', alignItems:'center', gap:'8px', fontSize:'14px' }}>
            <Link to={homeLink} style={{ textDecoration:'none', color:isDark?'#9ca3af':'#6b7280', fontWeight:500, fontFamily:"'DM Sans',sans-serif" }}>Home</Link>
            <span style={{ color:isDark?'#4b5563':'#d1d5db' }}>/</span>
            {/* <Link to="/MoreRotation" style={{ textDecoration:'none', color:isDark?'#9ca3af':'#6b7280', fontWeight:500, fontFamily:"'DM Sans',sans-serif" }}>Rotation</Link> */}
            {/* <span style={{ color:isDark?'#4b5563':'#d1d5db' }}>/</span> */}
            <span style={{ color:isDark?'#e5e7eb':'#111827', fontWeight:600, fontFamily:"'DM Sans',sans-serif" }}>Manage Rotation</span>
          </div>
        </section>

        {/* Stats */}
        <section className="ap-stats" style={{ flexShrink:0 }}>
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">TOTAL ROTATIONS</div>
              <div className="ap-stat-value">{rows.length}</div>
              <div className="ap-stat-badge green">↑ In system</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconRotation /></div>
          </div>

          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">ACTIVE ROTATIONS</div>
              <div className="ap-stat-value large">{activeCount}</div>
              <div className="ap-stat-badge green">Currently running</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconTrend /></div>
          </div>

          <div className="ap-stat-card dark-card">
            <div>
              <div className="ap-stat-label white">FILTERED RESULTS</div>
              <div className="ap-stat-value white">{filtered.length}</div>
              <div style={{ display:'flex', alignItems:'center', gap:'8px', marginTop:'12px' }}>
                <span className="ap-badge-pill">SHOWING NOW</span>
                <span style={{ color:'rgba(255,255,255,0.6)', fontSize:'11px' }}>of {rows.length} total</span>
              </div>
            </div>
            <div className="ap-stat-icon dark-icon"><IconRotation /></div>
          </div>
        </section>

        {/* Table Section */}
        <section
          className="ap-table-section"
          style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden', minHeight:0 }}
        >
          {/* header */}
          <div className="ap-table-header" style={{ flexShrink:0 }}>
            <div>
              <div className="ap-table-title-label">DISTRIBUTION</div>
              <div className="ap-table-title">ROTATIONS</div>
            </div>
            <div className="ap-table-actions">
              <div className="ap-search-inline">
                <IconSearch />
                <input
                  placeholder="Search by sales, project, or channel…"
                  value={searchTerm}
                  onChange={e => { setSearchTerm(e.target.value); setPage(1); }}
                />
              </div>
              <Link to="/MoreRotation" style={{ textDecoration:'none' }}>
                <button className="ap-create-btn"><IconPlus /> Add Rotation</button>
              </Link>
            </div>
          </div>

          {/* Table */}
          <div className="ap-table-wrap" style={{ flex:1, overflowY:'auto', overflowX:'auto' }}>
            <table className="ap-table">
              <thead>
                <tr>
                  {['', 'SALES', 'PROJECTS', 'CHANNEL', 'CREATED DATE', 'STATUS', 'ACTIONS'].map(h => (
                    <th key={h} style={{ position:'sticky', top:0, zIndex:2, background:isDark?'#1a1a2e':'#fff' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pageItems.length === 0 ? (
                  <tr><td colSpan={7} className="ap-empty"><IconSearch /><p>No rotations found</p></td></tr>
                ) : pageItems.map(row => (
                  <tr key={row.id} className="ap-row">
                    <td>
                      <CopyToClipboard text={row.id} onCopy={() => { setCopyOpen(true); setTimeout(()=>setCopyOpen(false),2000); }}>
                        <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
                      </CopyToClipboard>
                    </td>

                    <td>
                      <div style={{ fontSize:'13px', maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', color:isDark?'#e0e0ff':'#1f2937', fontWeight:500 }} title={row.sales}>
                        {row.sales || '—'}
                      </div>
                    </td>

                    <td>
                      <div style={{ fontSize:'12px', maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} className="ap-cell-muted" title={row.projects}>
                        {row.projects || '—'}
                      </div>
                    </td>

                    <td>
                      <div style={{ fontSize:'12px', maxWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} className="ap-cell-muted" title={row.channels}>
                        {row.channels || '—'}
                      </div>
                    </td>

                    <td className="ap-cell-muted" style={{ fontSize:'13px' }}>{row.createdAt}</td>

                    <td>
                      <span style={{
                        display:'inline-flex', alignItems:'center', gap:5,
                        padding:'3px 10px', borderRadius:'999px', fontSize:'11px', fontWeight:600,
                        background: row.active ? (isDark?'rgba(74,222,128,0.12)':'rgba(22,163,74,0.08)') : (isDark?'rgba(248,113,113,0.12)':'rgba(239,68,68,0.08)'),
                        color: row.active ? (isDark?'#4ade80':'#16a34a') : (isDark?'#f87171':'#ef4444'),
                        border: `1px solid ${row.active ? (isDark?'rgba(74,222,128,0.25)':'rgba(22,163,74,0.2)') : (isDark?'rgba(248,113,113,0.25)':'rgba(239,68,68,0.2)')}`,
                      }}>
                        <span style={{ width:5, height:5, borderRadius:'50%', backgroundColor:'currentColor' }} />
                        {row.active ? 'Active' : 'Inactive'}
                      </span>
                    </td>

                    <td>
                      <div className="ap-actions">
                        <Link to={`/EditMoreRotation/${row.id}`} className="mr-btn edit" title="Edit">
                          <IconEdit />
                        </Link>
                        <button className="mr-btn del" title="Delete" onClick={() => setDeleteId(row.id)}>
                          <IconTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filtered.length > 0 && (
            <div
              className="ap-pagination"
              style={{ position:'sticky', bottom:0, zIndex:5, flexShrink:0, backgroundColor:isDark?'#1a1a2e':'#fff', borderTop:`1px solid ${isDark?'#2a2a45':'#e8eaf0'}`, boxShadow:'0 -2px 12px rgba(0,0,0,0.06)' }}
            >
              <div className="ap-pagination-info">
                <span>Items per page:</span>
                <select className="ap-page-select" value={itemsPerPage} onChange={e=>{setItemsPerPage(Number(e.target.value));setPage(1);}}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span>Showing <strong>{(page-1)*itemsPerPage+1}–{Math.min(page*itemsPerPage,filtered.length)}</strong> of <strong>{filtered.length}</strong></span>
              </div>
              <div className="ap-pagination-btns">
                <button className="ap-pag-btn" onClick={()=>setPage(1)} disabled={page===1}>⟨|</button>
                <button className="ap-pag-btn" onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}>‹</button>
                {buildPageNumbers().map((n,i)=>n==='...'
                  ? <span key={`e-${i}`} className="ap-pag-ellipsis">…</span>
                  : <button key={n} className={`ap-pag-btn ${page===n?'active':''}`} onClick={()=>setPage(n)}>{n}</button>
                )}
                <button className="ap-pag-btn" onClick={()=>setPage(p=>Math.min(totalPages,p+1))} disabled={page===totalPages}>›</button>
                <button className="ap-pag-btn" onClick={()=>setPage(totalPages)} disabled={page===totalPages}>|⟩</button>
              </div>
            </div>
          )}
        </section>

        {/* Footer */}
        <footer className="ap-footer" style={{ flexShrink:0 }}>
          <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
        </footer>

      </div>

      {/* Delete Modal */}
      {deleteId && (
        <DeleteModal
          isDark={isDark}
          onClose={() => { if (!deleteLoading) setDeleteId(null); }}
          onConfirm={handleDelete}
          loading={deleteLoading}
        />
      )}

      <Snackbar open={copyOpen} autoHideDuration={2000}>
        <Alert severity="success" sx={{ width:'100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};
